module.exports = __webpack_public_path__ + "img/skillsChart.e509137d.svg";